import StartInfo from '../../UI/start-info';